(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueUniqIds"] = factory();
	else
		root["VueUniqIds"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createDirective = __webpack_require__(2);

var _createDirective2 = _interopRequireDefault(_createDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefix = 'uni-';

var defaultAttributes = ['aria-activedescendant', 'aria-controls', 'aria-describedby', 'aria-flowto', 'aria-labelledby', 'aria-labelledby', 'aria-owns', 'for', 'form', 'id'];

var defaultQinuTemplate = '%arg[0]%-%qinu%';

var createDirectives = function createDirectives(opts) {
  return opts.attrs.reduce(function (dirs, attr) {
    dirs['' + opts.prefix + attr] = (0, _createDirective2.default)(attr, opts);
    return dirs;
  }, {});
};

var createMixin = function createMixin(options) {
  var opts = _extends({ prefix: prefix, scope: {}, attrs: defaultAttributes, template: defaultQinuTemplate }, options);
  return {
    directives: createDirectives(opts)
  };
};

exports.default = createMixin;
module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.qinu = factory();
  }
})(undefined, function () {

  var defaultLength = 8;
  var defaultTemplate = '%qinu%';
  var defaultChars = '1234567890abcdefghijklmnopqrstuvwxyz';

  function generateString(chars, length, string) {
    if (typeof string === 'undefined') {
      return generateString(chars, length, '');
    }
    if (string.length >= length) {
      return string;
    }
    var randomIndex = Math.floor(Math.random() * chars.length);
    var newChar = chars[randomIndex];
    return generateString(chars, length, string + newChar);
  }

  function generate(opts, args) {
    var randomString = generateString(opts.chars, opts.length);
    var qinuString = opts.template.replace(/%qinu%/g, randomString);
    for (var i = args.length; i--;) {
      qinuString = qinuString.replace(new RegExp('%arg\\[' + i + '\\]%', 'g'), args[i]);
    }
    return qinuString;
  }

  function qinu(options, args) {
    options = options || {};
    var opts = {
      length: typeof options.length === 'number' ? options.length : defaultLength,
      template: options.template || defaultTemplate,
      chars: (options.chars || defaultChars).slice()
    };
    if (!(args instanceof Array)) {
      args = Array.prototype.slice.call(arguments, 1);
    }
    if (options.args) {
      args = options.args.concat(args);
    }
    return generate(opts, args);
  }

  qinu.create = function (opts) {
    return qinu.bind(null, opts);
  };

  return qinu;
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _generateIds = __webpack_require__(3);

var _generateIds2 = _interopRequireDefault(_generateIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doesNeedNewScope = function doesNeedNewScope(opts) {
  return _typeof(opts.scope) !== 'object' && typeof opts.scope !== 'undefined' && opts.scope;
};

function createDirective(attr) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (el, binding, vnode) {
    if (!vnode.context.$options.uniqIdsConfig) {
      vnode.context.$options.uniqIdsConfig = { scope: {} };
    }
    var localOpts = vnode.context.$options.uniqIdsConfig;
    if (doesNeedNewScope(localOpts)) {
      localOpts.scope = {};
    }
    var opts = _extends({}, options, localOpts);
    var scope = _typeof(localOpts.scope) === 'object' ? localOpts.scope : localOpts.scope && {} || options.scope || {};
    var value = binding.value;
    var ids = (0, _generateIds2.default)(value, scope, opts);
    if (ids) {
      el.setAttribute(attr, ids);
    } else {
      el.removeAttribute(attr);
    }
  };
}

exports.default = createDirective;
module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUniqId = __webpack_require__(4);

var _getUniqId2 = _interopRequireDefault(_getUniqId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateIds = function generateIds(value, scope, options) {
  var list = value instanceof Array ? value : (value || '').split(/\s+/);
  return list.map(function (id) {
    return (0, _getUniqId2.default)(scope, id, options);
  }).join(' ');
};

exports.default = generateIds;
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _qinu = __webpack_require__(1);

var _qinu2 = _interopRequireDefault(_qinu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUniqId = function getUniqId(scope, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!scope[id]) {
    scope[id] = (0, _qinu2.default)(options, id);
  }
  return scope[id];
};

exports.default = getUniqId;
module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniqIdsPlugin = exports.createUniqIdsMixin = undefined;

var _createMixin = __webpack_require__(0);

var _createMixin2 = _interopRequireDefault(_createMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UniqIdsPlugin = {
  install: function install(Vue, options) {
    Vue.mixin((0, _createMixin2.default)(options));
  }
};

exports.createUniqIdsMixin = _createMixin2.default;
exports.UniqIdsPlugin = UniqIdsPlugin;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-uniq-ids.min.js